import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry when REACT_APP_SENTRY_DSN is set; otherwise no-op.
 * Import and call once before React render (see index.js).
 */
export function initDashboardSentry() {
  const dsn = (process.env.REACT_APP_SENTRY_DSN || '').trim();
  if (!dsn) {
    return false;
  }

  const tracesSampleRate = Number(
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0
  );

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'development',
    tracesSampleRate: Number.isFinite(tracesSampleRate) ? tracesSampleRate : 0,
  });

  // Operator hook for manual Sentry verification (browser console: __sentryCaptureTest()).
  if (typeof window !== 'undefined') {
    window.__sentryCaptureTest = () => {
      Sentry.captureException(new Error('Sentry frontend test (captureException)'));
    };
  }

  // Dev-only uncaught-error hook (browser console: __sentryTestError()).
  if (process.env.REACT_APP_DEBUG === 'true' && typeof window !== 'undefined') {
    window.__sentryTestError = () => {
      throw new Error('Sentry dashboard test error (REACT_APP_DEBUG)');
    };
  }

  return true;
}

export function SentryErrorFallback({ error, resetError, eventId }) {
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        padding: 24,
        background: '#0d1117',
        color: '#f0f6fc',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <h1 style={{ marginTop: 0 }}>Something went wrong</h1>
      <p>{error?.message || 'An unexpected error occurred.'}</p>
      {eventId ? <p style={{ opacity: 0.8 }}>Reference: {eventId}</p> : null}
      <button
        type="button"
        onClick={resetError}
        style={{
          marginTop: 16,
          padding: '8px 16px',
          cursor: 'pointer',
        }}
      >
        Try again
      </button>
    </div>
  );
}

export { Sentry };
